"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonColors = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getButtonColors = function getButtonColors(theme) {
  var colors = theme.colors;
  var buttonColors = {};
  var defaultLight = {
    color: colors.light
  };
  var defaultDark = {
    color: colors.dark
  };
  return {
    primary: _objectSpread(_objectSpread({}, defaultLight), {}, {
      background: colors.primary,
      borderColor: colors.primary
    }),
    purple: _objectSpread(_objectSpread({}, defaultLight), {}, {
      background: colors.purple,
      borderColor: colors.purple
    }),
    dark: _objectSpread(_objectSpread({}, defaultLight), {}, {
      background: colors.dark,
      borderColor: colors.dark
    }),
    maxBluePurple: _objectSpread(_objectSpread({}, defaultLight), {}, {
      background: colors.maxBluePurple,
      borderColor: colors.maxBluePurple
    }),
    independence: _objectSpread(_objectSpread({}, defaultLight), {}, {
      background: colors.independence,
      borderColor: colors.independence
    }),
    spanishGray: _objectSpread(_objectSpread({}, defaultLight), {}, {
      background: colors.spanishGray,
      borderColor: colors.spanishGray
    }),
    princetonOrange: _objectSpread(_objectSpread({}, defaultLight), {}, {
      background: colors.princetonOrange,
      borderColor: colors.princetonOrange
    }),
    silver: _objectSpread(_objectSpread({}, defaultLight), {}, {
      background: colors.silver,
      borderColor: colors.silver
    }),
    purpleNavy: _objectSpread(_objectSpread({}, defaultLight), {}, {
      background: colors.purpleNavy,
      borderColor: colors.purpleNavy
    }),
    green: _objectSpread(_objectSpread({}, defaultLight), {}, {
      background: colors.green,
      borderColor: colors.green
    }),
    lightRed: _objectSpread(_objectSpread({}, defaultLight), {}, {
      background: colors.lightRed,
      borderColor: colors.lightRed
    }),
    orange: _objectSpread(_objectSpread({}, defaultLight), {}, {
      background: colors.orange,
      borderColor: colors.orange
    }),
    red: _objectSpread(_objectSpread({}, defaultLight), {}, {
      background: colors.red,
      borderColor: colors.red
    }),
    light: _objectSpread(_objectSpread({}, defaultDark), {}, {
      background: colors.light,
      borderColor: colors.light
    }),
    cultured: _objectSpread(_objectSpread({}, defaultDark), {}, {
      background: colors.cultured,
      borderColor: colors.cultured
    }),
    platinum: _objectSpread(_objectSpread({}, defaultDark), {}, {
      background: colors.platinum,
      borderColor: colors.platinum
    }),
    lavender: _objectSpread(_objectSpread({}, defaultDark), {}, {
      background: colors.lavender,
      borderColor: colors.lavender
    }),
    darkCultured: _objectSpread(_objectSpread({}, defaultDark), {}, {
      background: colors.darkCultured,
      borderColor: colors.darkCultured
    }),
    yellow: _objectSpread(_objectSpread({}, defaultDark), {}, {
      background: colors.yellow,
      borderColor: colors.yellow
    }),
    darkSilver: _objectSpread(_objectSpread({}, defaultLight), {}, {
      background: colors.darkSilver,
      borderColor: colors.darkSilver
    })
  };
};
exports.getButtonColors = getButtonColors;